/**
 * Central brand configuration.
 *
 * Every user-facing brand string should read from here so a future white-label
 * is a one-file change instead of a find-and-replace across the codebase.
 */
export const brand = {
  name: "Your Brand",
  legalName: "Your Company, LLC",
  shortName: "Your Brand",
  tagline: "Real care. Real value. No insurance required.",
  domain: "your-branded-domain.com",
  siteUrl: "https://your-branded-domain.com",
  statementDescriptor: "YOUR BRAND",
  email: {
    support: "info@your-branded-domain.com",
    billing: "ap@your-branded-domain.com",
  },
  social: {
    facebook: "https://www.facebook.com/yourbrand",
    x: "https://x.com/yourbrand",
    instagram: "https://www.instagram.com/yourbrand/",
  },
} as const;

export type Brand = typeof brand;
